import { useState, useEffect } from "react";
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Box, Collapse, Flex } from "@chakra-ui/react";
import InputTextAreaExpandable from './InputTextAreaExpandable';
import { IoMdImage } from 'react-icons/io';
import { DsrLoomRecordButton } from "../../../digital-sales-room/dsr-record-content/DsrLoomRecordButton";
import DsrPostImagesUpload from "../../../digital-sales-room/dsr-create-post/DsrPostImagesUpload";
import InputTextAreaWithUserTagging from "./InputTextAreaWithUserTagging";
import { bindActionCreators } from "redux";
import {
  tagUserInPost,
  untagUserInPost,
  tagUserInReply,
  untagUserInReply
} from "../../../digital-sales-room/actions/user-tag-actions";
import { getDsrUpdatedFeedContent } from "../../../digital-sales-room/actions/dsr-actions";
import LaunchdeckButton from "../../../global/components/helper-components/components/LaunchdeckButton";
import LaunchdeckCreatePostButton from "../../../global/components/helper-components/components/LaunchdeckCreatePostButton";
import WarningTextMessage from "../../../global/components/helper-components/components/WarningTextMessage";
import LaunchdeckCloseButton from "../../../global/components/helper-components/components/LaunchdeckCloseButton";
import LaunchdeckImageCarousel from "../../../global/components/helper-components/components/LaunchdeckImageCarousel";
import { BiUndo } from "react-icons/bi";
import { MdHideImage } from "react-icons/md";
import { displayReactIcon } from "../../../digital-sales-room/helpers/dsr-display-helpers";
import LaunchdeckTextLoader from "../../../global/components/helper-components/components/LaunchdeckTextLoader";
import { manageDsrFaqContent } from "../../../digital-sales-room/actions/dsr-faq-actions";


function DsrPostTextAreaInput({ dsrId, postId, replyId, originalPostType, dsrFeedContent, htmlFor, currentValue, placeholder,
  onClickCreatePost, userActionRequired, onClickEditPost, onClickCreateReply,
  createNewDsrFeedPostOutcome, editDsrFeedPostOutcome, createNewDsrFeedReplyOutcome,
  editDsrFeedReplyOutcome, tagUserInPost, untagUserInPost,
  tagUserInReply, untagUserInReply, postTagProperties, getDsrUpdatedFeedContent,
  dsrTeamMembers, showPostUploadImageOption, handleCloseWithoutAction,
  isLoading, containsImages, imageArray, name,
  isMobileView,
  manageDsrFaqContent,
  dsrTemplateId, isRoomTemplate
}) {


  const [thisDsrTeamMembers, setAllDsrTeamMembers] = useState(null);
  const [inputValue, setInputValue] = useState(currentValue || "");
  const [files, setFiles] = useState([]);
  const [loomVideo, setLoomVideo] = useState(null);
  const [postType, setPostType] = useState(null)

  const [displayEmptyInputError, setDisplayEmptyInputError] = useState(false)
  const [isInvalidInput, setIsInvalidInput] = useState("");
  const [previewLink, setPreviewLink] = useState(null)



  // Upload feature management
  const [showUploadImageOption, setShowUploadImageOption] = useState(showPostUploadImageOption)
  // const [showUploadVideoOption, setShowUploadVideoOption] = useState(false)
  // const [showDismissButton, setShowDismissButton] = useState(false)

  // User tagging feature management
  const [userTagProperties, setUserTagProperties] = useState(postTagProperties ? postTagProperties : [])
  const [taggedUserIds, setTaggedUserIds] = useState([]);
  const [untaggedUserIds, setUntaggedUserIds] = useState([]);
  const [replyTagProperties, setReplyTagProperties] = useState([]);

  // UX Edit posts
  const [isProcessing, setIsProcessing] = useState(null)
  const [showInputBorder, setShowInputBorder] = useState(false)
  const [removeEditImages, setRemoveEditImages] = useState(false);
  const [showRemoveButton, setShowRemoveButton] = useState(false);
  const [validationError, setValidationError] = useState(null)

  useEffect(() => {
    // Tagging on post creating / Tagging post editing / Reply tagging
    let updatedUserTagProperties = replyId ? replyTagProperties : postTagProperties ? [...postTagProperties] : [];

    for (const taggedUserId of taggedUserIds) {
      const foundIndex = Array.isArray(updatedUserTagProperties) && updatedUserTagProperties?.findIndex(taggedUser => taggedUser.taggedUserId === taggedUserId)

      if (foundIndex < 0) {
        const userTagObject = {
          taggedUserId,
          notificationSent: null,
          untagged: false,
          taggedAt: new Date().toISOString(),
          tagPostId: postId || null,
        }
        updatedUserTagProperties = [...updatedUserTagProperties, userTagObject]
      }

      setUserTagProperties([...updatedUserTagProperties])
    }

  }, [taggedUserIds, untaggedUserIds]);


  useEffect(() => {
    if (dsrTeamMembers) {
      const { sellerTeam, buyerTeam } = dsrTeamMembers || {};
      const allMembersArray = (sellerTeam && buyerTeam) ? [...sellerTeam, ...buyerTeam] : [...sellerTeam]
      setAllDsrTeamMembers(allMembersArray)
    }

  }, [dsrTeamMembers]);

  useEffect(() => {
    if (dsrFeedContent) {
      const post = dsrFeedContent.find(post => { return post.postId === postId })
      const reply = post?.postReplies.find(reply => { return reply.replyId === replyId })

      if (reply && reply.replyTaggedUsers.length > 0) {
        setReplyTagProperties([...reply.replyTaggedUsers])
      }
    }

  }, [dsrFeedContent, postId, replyId]);

  useEffect(() => {
    if (!inputValue) {
      setDisplayEmptyInputError(true)
    } else {
      setDisplayEmptyInputError(false)
    }
  }, [inputValue]);


  //Tagging in post
  useEffect(() => {
    if (createNewDsrFeedPostOutcome && taggedUserIds) {
      const { newPostCreated } = createNewDsrFeedPostOutcome || {};

      if (newPostCreated) {
        usersTagging(dsrId, newPostCreated.postId).then()
      }
    }
  }, [createNewDsrFeedPostOutcome]);

  useEffect(() => {
    if (editDsrFeedPostOutcome) {
      const { updatedSuccessfully } = editDsrFeedPostOutcome || {};

      if (updatedSuccessfully) {
        if (taggedUserIds.length > 0) {
          usersTagging(dsrId, postId).then()
        }

        if (untaggedUserIds.length > 0) {
          usersUntagging(dsrId, postId).then()
        }
      }
    }

  }, [editDsrFeedPostOutcome]);

  const usersTagging = async (dsrId, postId) => {

    for (const userId of taggedUserIds) {
      const foundIndex = Array.isArray(userTagProperties) && userTagProperties?.findIndex(taggedUser => taggedUser.taggedUserId === userId)

      if (userTagProperties[foundIndex].notificationSent !== true || userTagProperties[foundIndex].untagged === true) {
        await tagUserInPost({ dsrId, postId, taggedUserId: userId })
      }
    }

    getDsrUpdatedFeedContent(dsrId);
  }

  const usersUntagging = async (dsrId, postId) => {
    for (const userId of untaggedUserIds) {

      const foundIndex = Array.isArray(userTagProperties) && userTagProperties?.findIndex(taggedUser => taggedUser.taggedUserId === userId)
      if (userTagProperties[foundIndex].untagged === false) {
        await untagUserInPost({ dsrId: dsrId, postId: postId, untaggedUserId: userId })
      }
    }

    getDsrUpdatedFeedContent(dsrId);
  }

  //Tagging in replies

  useEffect(() => {
    if (createNewDsrFeedReplyOutcome && taggedUserIds && dsrId && postId) {
      const { newReplyId } = createNewDsrFeedReplyOutcome || {};

      if (newReplyId) {
        usersTaggingInReply({ dsrId: dsrId, postId: postId, replyId: newReplyId }).then()
      }

    }
  }, [createNewDsrFeedReplyOutcome]);

  useEffect(() => {
    if (editDsrFeedReplyOutcome) {
      const { updatedSuccessfully, updatedReplyId } = editDsrFeedReplyOutcome || {};

      if (updatedSuccessfully && updatedReplyId) {
        if (taggedUserIds.length > 0) {
          usersTaggingInReply({ dsrId: dsrId, postId: postId, replyId: updatedReplyId }).then()
        }

        if (untaggedUserIds.length > 0) {
          usersUntaggingInReply({ dsrId: dsrId, postId: postId, replyId: updatedReplyId }).then()
        }
      }
    }

  }, [editDsrFeedReplyOutcome]);


  const usersTaggingInReply = async ({ dsrId, postId, replyId }) => {
    for (const userId of taggedUserIds) {
      const foundIndex = Array.isArray(userTagProperties) && userTagProperties?.findIndex(taggedUser => taggedUser.taggedUserId === userId)

      if (userTagProperties[foundIndex].notificationSent !== true || userTagProperties[foundIndex].untagged === true) {
        await tagUserInReply({ dsrId: dsrId, postId: postId, replyId: replyId, taggedUserId: userId })
      }
    }

    getDsrUpdatedFeedContent(dsrId);
  }

  const usersUntaggingInReply = async ({ dsrId, postId, replyId }) => {
    for (const userId of untaggedUserIds) {
      const foundIndex = Array.isArray(userTagProperties) && userTagProperties?.findIndex(taggedUser => taggedUser.taggedUserId === userId)

      if (userTagProperties[foundIndex].untagged === false) {
        await untagUserInReply({ dsrId: dsrId, postId: postId, replyId: replyId, untaggedUserId: userId })
      }
    }

    getDsrUpdatedFeedContent(dsrId);
  }

  const onChangeHandler = event => {
    setInputValue(event.target.value);


    !!validationError && setValidationError(false)
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const urls = event.target.value.match(urlRegex);
    const containsTwoDots = (event.target.value.match(/\./g) || []).length >= 2;

    if (urls && urls.length === 1 && containsTwoDots) {

      setPreviewLink(urls[0]);
      setPostType("shared-url")
    } else {
      setPreviewLink(null)
    }

    setIsInvalidInput("")
  };

  const handleDismissPreviewLink = () => {
    setPreviewLink(null)
    setPostType("short-text")
  }

  const handleClickCreateReply = () => {
    const newReplyContent = {
      "replyContent": inputValue,
      "postId": postId
    }
    onClickCreateReply(newReplyContent)
    setInputValue("")
  }

  const getFiles = (files, type) => {
    setPostType(type)
    if (type === "loom-video-post") {
      setLoomVideo(files)
    } else {
      setFiles(files)
    }
  }

  const resetFileUploadState = () => {
    setFiles([]);
    // setShowUploadVideoOption(false)
    setShowUploadImageOption(false);
  }


  switch (userActionRequired) {
    case ('create-new-post'): {
      // TODO: This is not working well because this is rendered 4x when creating new post modal is being pulled up
      // Investigate and contrast with FileUPloadProgress since that one was showing the right number. 
      const tempUxPostId = "temp-pst__new_post";

      return (
        <Box py='1em' w='100%' bg='white' rounded='0.25em'>
          <>
            <Flex justify='flex-start' width='100%' px='1em' minH='4em'>
              <InputTextAreaWithUserTagging
                onChangeHandler={onChangeHandler}
                inputValue={inputValue}
                previewLink={previewLink}
                placeholder={placeholder}
                dsrTeamMembers={thisDsrTeamMembers}
                userTagProperties={userTagProperties}
                taggedUserIds={taggedUserIds}
                setTaggedUserIds={setTaggedUserIds}
                untaggedUserIds={untaggedUserIds}
                setUntaggedUserIds={setUntaggedUserIds}
                handleDismissPreviewLink={handleDismissPreviewLink}
                minH='6em'
                disableInput={isLoading}
                name={name}
              />
            </Flex>

            {(files.length === 0 && !showUploadImageOption) && !previewLink
              // && !showUploadVideoOption 
              &&
              <Flex w='100%' justify='space-between' align='baseline' px='1em' pt='3em' className='fade-in'>
                <Flex>
                  <Flex justify='center' align='center' bg='gray.50' border='1px solid' borderColor='brand.100' rounded='0.25em' p='0.2em 0.5em' cursor='pointer'
                    onClick={() => {
                      setShowUploadImageOption(true);
                      // setShowUploadVideoOption(false)
                    }} >

                    <Box as={IoMdImage} boxSize="1.2em" color='brand.500' />
                    <Box fontSize='0.75em' ml='0.5em'>Add Images</Box>
                  </Flex>

                </Flex>
              </Flex>}
          </>



          {/* {showUploadVideoOption &&
              <Flex direction='column' justifyContent="center" alignItems="center"
                bg='gray.50'
                border='1px dashed' borderColor='gray.300' rounded='0.5em' m='1em'>
                <Flex w='100%' justify='flex-end' p='0.5em'>
                  {showDismissButton ?
                    <LaunchdeckButton bg='gray.100' color='brandDark.500' border='1px solid' borderColor='gray.400' p='0.2em 1em' fontSize='0.7em' onClick={() => resetFileUploadState()} label='Remove video' />
                    :
                    <LaunchdeckCloseButton handleCloseModal={() => resetFileUploadState()} />
                  }
                </Flex>

                <DsrVideoUpload getFiles={getFiles} setShowDismissButton={setShowDismissButton} />
              </Flex>
            } */}

          <Box as={Collapse} display='flex' align='center' in={showUploadImageOption} w="100%" maxW='670px'>
            {showUploadImageOption &&
              <Flex
                w='100%'
                direction='column' justifyContent="center" alignItems="center" bg='gray.100' rounded='0.5em'
                opacity={isLoading ? 0.5 : 1.0}
              >
                <Flex w='100%' justify='space-between' align='center' p='0.5em'>
                  <Flex justify='flex-start' align='center' gap='0.5em' color='brandDark.500' fontSize='0.75em' px='0.5em' fontWeight='600' letterSpacing={'1px'}>{displayReactIcon('add-image', '1em')} ADD IMAGE(S)</Flex>
                  {!isLoading && <LaunchdeckCloseButton handleCloseModal={() => resetFileUploadState()} />}
                </Flex>
                <DsrPostImagesUpload getFiles={getFiles} isProcessing={isLoading} />
              </Flex>
            }
          </Box>




          <Flex flex='1' mt='1em' justify={['center', 'flex-end']}>
            <Flex mt='0.625em' align='center' justify='flex-end' px='1em' gap='0.5em' w='100%'>

              {(isLoading && files) && <LaunchdeckTextLoader copyText="Saving" color='gray.500' fontSize='0.7em' postId={tempUxPostId} />}

              <LaunchdeckCreatePostButton
                label='Create Post'
                inputValue={inputValue}
                files={files}
                postType={postType}
                onClickCreatePost={onClickCreatePost}
                showUploadImageOption={showUploadImageOption}
                userActionRequired={userActionRequired}
                userTagProperties={userTagProperties}
                tempUxPostId={tempUxPostId}
                loadingLogic={isLoading}
                width={isMobileView && '100%'}
              />
            </Flex>
          </Flex>
        </Box>
      );
    }
    case ('edit-dsr-message-post'): {
      const updatedPostContent = {
        "postContent": inputValue,
        "postIdToEdit": postId,
      }

      const contentChanged = (!!removeEditImages || (inputValue !== currentValue)) ? true : false

      return (
        <Flex
          direction='column'
          mb='1.8em'
          mx='1em'
          htmlFor={htmlFor}
          w='100%'
          transition='all 0.5s ease-in-out'
        >

          <Box
            onFocus={() => setShowInputBorder(true)}
            onBlur={() => setShowInputBorder(false)}
            transition="border-color 0.2s ease-in-out"
            mt='0.625em'
            border={'1px solid'}
            borderColor={!isLoading && !!showInputBorder ? 'gray.300' : 'transparent'}
            rounded='0.25em'
            p='0.5em 0.875em'
          >
            <InputTextAreaWithUserTagging
              onChangeHandler={onChangeHandler}
              inputValue={inputValue}
              previewLink={previewLink}
              placeholder={placeholder}
              dsrTeamMembers={thisDsrTeamMembers}
              userTagProperties={userTagProperties}
              taggedUserIds={taggedUserIds}
              setTaggedUserIds={setTaggedUserIds}
              untaggedUserIds={untaggedUserIds}
              setUntaggedUserIds={setUntaggedUserIds}
              handleDismissPreviewLink={handleDismissPreviewLink}
              minH='4em'
              disableInput={isLoading}
              name={name}
            />
            <WarningTextMessage errorLogic={displayEmptyInputError} message='Your edited post is empty' />
          </Box>

          {/* // Edit Post with images */}
          {!!containsImages && !!imageArray && !showUploadImageOption &&
            <Flex
              position='relative'
              width="100%"
              justify='center'
              align='flex-start'
              overflow="hidden"
              mt='1em'
              pt='1em'
              onMouseOver={() => setShowRemoveButton(true)}
              onMouseLeave={() => setShowRemoveButton(false)}
            >
              {(removeEditImages) ?
                <Flex w='100%' gap='0.5em' justify='flex-start' align='baseline' className='fade-in'>
                  <Flex justify='center' align='center' bg='gray.50' border='1px solid' borderColor='gray.400' rounded='0.25em' p='0.2em 0.5em' cursor='pointer'
                    onClick={() => { setRemoveEditImages(false) }} >
                    <Box as={BiUndo} boxSize="1.2em" color='brandDark.500' />
                    <Box fontSize='0.75em' ml='0.5em'>Restore images</Box>
                  </Flex>


                  <Flex justify='center' align='center' bg='gray.50' border='1px solid' borderColor='brand.100' rounded='0.25em' p='0.2em 0.5em' cursor='pointer'
                    onClick={() => {
                      setShowUploadImageOption(true);
                      //  setShowUploadVideoOption(false)
                    }} >

                    <Box as={IoMdImage} boxSize="1.2em" color='brand.500' />
                    <Box fontSize='0.75em' ml='0.5em'>Add new images</Box>
                  </Flex>

                </Flex>
                :
                <Box className='fade-in' >
                  <Flex position='absolute' justify='center' align='center' bg='brandPink.500' gap='0.5em' rounded='0.875em' p='0.4em 0.8em' top='1.5em' right='1.5em' zIndex='600' color='white'
                    cursor='pointer' onClick={() => { setRemoveEditImages(true) }}
                    opacity={showRemoveButton ? 1.0 : 0}
                    transition="all 0.2s ease-in-out"
                    display={isLoading ? 'none' : 'flex'}
                  >
                    <Box as={MdHideImage} boxSize="0.8em" color='inherit' />
                    <Box fontSize='0.65em' >Remove</Box>
                  </Flex>
                  <Box w='100%' position='relative' maxWidth="650px" opacity={isLoading ? 0.5 : 1.0}>
                    <LaunchdeckImageCarousel imageArray={imageArray} isProcessing={isLoading} />
                  </Box>
                </Box>
              }
            </Flex>
          }

          {/* // Edit Post with text only */}
          {originalPostType === "short-text" && !showUploadImageOption &&
            <Flex
              position='relative'
              width="100%"
              justify='center'
              align='flex-start'
              overflow="hidden"
              mt='1em'
              pt='1em'>

              <Flex w='100%' gap='0.5em' justify='flex-start' align='baseline' className='fade-in'>
                <Flex justify='center' align='center' bg='gray.50' border='1px solid' borderColor='brand.100' rounded='0.25em' p='0.2em 0.5em' cursor='pointer'
                  onClick={() => {
                    setShowUploadImageOption(true);
                    setRemoveEditImages(true)
                    //  setShowUploadVideoOption(false)
                  }} >

                  <Box as={IoMdImage} boxSize="1.2em" color='brand.500' />
                  <Box fontSize='0.75em' ml='0.5em'>Add image</Box>
                </Flex>

              </Flex>
            </Flex>
          }

          <Box as={Collapse} display='flex' align='center' in={showUploadImageOption} w="100%" maxW='670px'>
            {showUploadImageOption &&
              <Flex
                w='100%'
                direction='column' justifyContent="center" alignItems="center" bg='gray.100' rounded='0.5em' my='1em'
                opacity={isLoading ? 0.5 : 1.0}
              >
                <Flex w='100%' justify='space-between' align='center' p='0.5em'>
                  <Flex justify='flex-start' align='center' gap='0.5em' color='brandDark.500' fontSize='0.75em' px='0.5em' fontWeight='600' letterSpacing={'1px'}>{displayReactIcon('add-image', '1em')} ADD IMAGE</Flex>
                  {!isLoading && <LaunchdeckCloseButton handleCloseModal={() => resetFileUploadState()} />}
                </Flex>
                <DsrPostImagesUpload getFiles={getFiles} isProcessing={isLoading} />
              </Flex>
            }
          </Box>

          <Flex w='100%' mt='1em' justify='center' alignItems='center'>
            <Flex justify={['center', 'flex-end', 'flex-end', 'flex-end']} align='center' direction={['column', 'row']} gap='1em' w='100%'>
              <Flex justify='center' align='center' gap='0.5em'>
                {(isLoading && files) && <LaunchdeckTextLoader copyText="Creating post" color='gray.500' fontSize='0.7em' postId={postId} />}
              </Flex>

              <LaunchdeckButton
                bg='brand.500'
                color={displayEmptyInputError ? 'gray.500' : 'white'}
                loadingLogic={isLoading}
                width={isMobileView && "100%"}
                onClick={((displayEmptyInputError === false) && (contentChanged) && !isLoading)
                  ? () => {
                    onClickEditPost({
                      ...updatedPostContent,
                      replaceImage: removeEditImages,
                      ...(removeEditImages && { files: files })
                    })
                  }
                  : (!contentChanged) ? () => handleCloseWithoutAction()
                    : undefined
                }
                label='Save changes'
              />
            </Flex>
          </Flex>
        </Flex>
      )
    }
    case ('create-new-reply'): {
      return (
        <Box htmlFor={htmlFor} w='100%'>
          <Box p='0.5em 0.875em' mt='0.5em' border='1px solid' borderColor='gray.300' rounded='0.25em' bg='white'>
            <InputTextAreaWithUserTagging
              onChangeHandler={onChangeHandler}
              inputValue={inputValue}
              previewLink={previewLink}
              placeholder={placeholder}
              dsrTeamMembers={thisDsrTeamMembers}
              userTagProperties={userTagProperties}
              taggedUserIds={taggedUserIds}
              setTaggedUserIds={setTaggedUserIds}
              untaggedUserIds={untaggedUserIds}
              setUntaggedUserIds={setUntaggedUserIds}
              handleDismissPreviewLink={handleDismissPreviewLink}
              minH='6em'
              name={name}
            />
          </Box>
          <WarningTextMessage errorLogic={isInvalidInput} message='Empty reply message' />
          <Flex mt='1em' justify='flex-end' w='100%'>

            <LaunchdeckButton bg='brand.500' color='white' py='0.4em' fontSize='0.8em' onClick={() => inputValue.trim().length > 0 ? handleClickCreateReply() : setIsInvalidInput(true)} label='Comment' />

          </Flex>
        </Box>
      );
    }
    case ('edit-dsr-reply'): {
      const updatedPostContent = {
        "replyContent": inputValue,
        "postIdToEdit": postId,
        "replyIdToEdit": replyId
        // TODO: Consider adding tagged users,
      }

      return (
        <Flex direction='column' mb='1.2em' mx='1em' htmlFor={htmlFor} w='100%'>
          <Box mt='0.875em' border={!isLoading && '1px solid'} borderColor='gray.300' rounded='0.25em' p='0.5em 0.875em'>
            <InputTextAreaWithUserTagging
              onChangeHandler={onChangeHandler}
              inputValue={inputValue}
              previewLink={previewLink}
              placeholder={placeholder}
              dsrTeamMembers={thisDsrTeamMembers}
              userTagProperties={userTagProperties}
              taggedUserIds={taggedUserIds}
              setTaggedUserIds={setTaggedUserIds}
              untaggedUserIds={untaggedUserIds}
              setUntaggedUserIds={setUntaggedUserIds}
              handleDismissPreviewLink={handleDismissPreviewLink}
              minH='4em'
              disableInput={isLoading}
              name={name}
            />
            <WarningTextMessage errorLogic={displayEmptyInputError} message='Your edited reply is empty' />
          </Box>

          <Flex w='100%' mt='1.5em' justify='center' alignItems='center'>
            <Flex justify={['center', 'flex-end']} w='100%'>
              <LaunchdeckButton bg='brand.500' color='white' w={isMobileView && '100%'} loadingLogic={isLoading} onClick={(displayEmptyInputError === false) ? () => onClickEditPost(updatedPostContent) : null} label='Save' />
            </Flex>
          </Flex>
        </Flex>
      )
    }
    case ('create-faq-question'): {
      // From updates page
      // Use Create new post to manage this process to guide UX
      return (
        <Box w='100%' bg='white' rounded='0.25em'>
          <Flex justify='flex-start' width='100%' px='1em'>
            <InputTextAreaExpandable
              onChangeHandler={onChangeHandler}
              inputValue={inputValue}
              placeholder={placeholder}
              name={name}
              autoFocus={true}
            />
          </Flex>

          <Flex flex='1' mt='1em' justify={['center', 'flex-end']}>
            <Flex mt='0.625em' px={['1.5em', '1em']} w={isMobileView && "100%"}>
              <LaunchdeckCreatePostButton
                label='Post'
                inputValue={inputValue}
                onClickCreatePost={onClickCreatePost}
                userActionRequired={userActionRequired}
                width={isMobileView && "100%"}
              />
            </Flex>
          </Flex>

        </Box>
      );
    }
    case ('create-question-in-faq-page'): {
      // From FAQ page
      const handleCreateFaqQuestion = () => {
        if (!inputValue || !inputValue?.trim()) {
          setValidationError(true)
        } else {
          setIsProcessing(true)
          const createFaqQuestionMetadata = {
            processEvent: 'create-faq-question',
            payload: {
              dsrId: isRoomTemplate ? dsrTemplateId : dsrId,
              faqQuestionContent: inputValue,
              isRoomTemplate
            }
          };

          manageDsrFaqContent(createFaqQuestionMetadata)
        }
      }

      return (
        <Box py='1em' w='100%' bg='white' rounded='0.25em'>
          <Flex justify='flex-start' width='100%' px='1em'>
            <InputTextAreaExpandable
              onChangeHandler={onChangeHandler}
              inputValue={inputValue}
              placeholder={placeholder}
              name={name}
              autoFocus={true}
            />
          </Flex>

          <Flex flex='1' mt='1em' justify={['center', 'flex-end']}>
            <Flex mt='0.625em' px={['1.5em', '1em']} w={isMobileView && "100%"}>
              <LaunchdeckButton
                label='Create question'
                bg={inputValue ? 'brand.500' : 'gray.300'}
                color={inputValue ? 'white' : "gray.700"}
                transition="all 0.2s ease-in-out"
                loadingLogic={isProcessing}
                dummy={!!validationError}
                w={isMobileView && "100%"}
                onClick={() => validationError ? undefined : handleCreateFaqQuestion(inputValue)}
              />
            </Flex>
          </Flex>

        </Box>
      );
    }
    // case ('create-faq-question-in-template'): {
    //   return (
    //     <Box py='1em' w='100%' bg='white' rounded='0.25em'>
    //       <Flex justify='flex-start' width='100%' px='1em'>
    //         <InputTextAreaExpandable
    //           onChangeHandler={onChangeHandler}
    //           inputValue={inputValue}
    //           placeholder={placeholder}
    //           name={name}
    //         />
    //       </Flex>


    //       <Flex flex='1' mt='1em' justify='flex-end' borderTop='1px solid' borderTopColor='gray.100'>
    //         <Flex mt='0.625em' px='1em'>
    //           <LaunchdeckButton bg='brand.500' color='white' onClick={() => onClickCreatePost(inputValue)} label='Create question' />
    //         </Flex>
    //       </Flex>

    //     </Box>
    //   );
    // }
    case ('create-video-post'): {
      return (
        <Box py='1em' w='100%' bg='white' rounded='0.25em'>
          <Flex justify='flex-start' width='100%' px='1em'>
            <InputTextAreaExpandable
              onChangeHandler={onChangeHandler}
              inputValue={inputValue}
              placeholder={placeholder}
              fontSize='0.875em'
              name={name}
            />
          </Flex>
          <Flex w='100%' justify='flex-end' align='center' px='1em' pt='1em'>
            <DsrLoomRecordButton getFiles={getFiles} sending={false} submitRecording={(v) => { }} />
          </Flex>
          <Flex flex='1' mt='1em' justify='flex-end' borderTop='1px solid' borderTopColor='gray.100'>
            <Flex mt='0.625em' px='1em'>
              <LaunchdeckCreatePostButton
                label='Create Video Post'
                inputValue={inputValue}
                loomVideo={loomVideo}
                postType={postType}
                onClickCreatePost={onClickCreatePost}
                userActionRequired={userActionRequired}
                userTagProperties={userTagProperties}
              />
            </Flex>
          </Flex>
        </Box>
      );
    }
    default: {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  createNewDsrFeedPostOutcome: state.createNewDsrFeedPostOutcome.results.data,
  editDsrFeedPostOutcome: state.editDsrFeedPostOutcome.results.data,
  dsrFeedContent: state.dsrFeedContent.results,
  dsrTeamMembers: state.dsrTeamMembers.members,
  dsrTemplateId: state.dsrTemplateId.results,
  isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
  isMobileView: state.mobileViewMode.isMobileView,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tagUserInPost,
      untagUserInPost,
      tagUserInReply,
      untagUserInReply,
      getDsrUpdatedFeedContent,
      manageDsrFaqContent
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrPostTextAreaInput))
